import React, { useEffect } from "react";
import { Line } from "react-chartjs-2";

// Custom plugin to display "No data found" message
const noDataPlugin = {
  id: "noDataPlugin",
  afterDraw: (chart) => {
    const { datasets } = chart.data;
    let hasData = false;

    // Check if any dataset has data
    for (let i = 0; i < datasets.length; i++) {
      if (datasets[i].data.length > 0) {
        hasData = true;
        break;
      }
    }

    // If no data, display "No data found"
    if (!hasData) {
      const ctx = chart.ctx;
      const width = chart.width;
      const height = chart.height;

      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "rgba(0, 0, 0, 0.8)";
      ctx.font = "16px Arial";
      ctx.fillText("No data found", width / 2, height / 2);
      ctx.restore();
    }
  },
};

const SecondLineChart = ({
  dataInfo,
  labelData,
  lowerLimitData,
  higherLimitData = [],
  controlLineData = [],
  dataSet,
}) => {
  const dataSetName = dataSet || [];
  const highlightColor = "red"; // Color for highlighting points

  useEffect(() => {
    console.log(`lowerLimit data:${lowerLimitData}`);
    console.log(`Hightlimit data:${higherLimitData}`);
  }, [lowerLimitData, higherLimitData]);

  function getDateLabels(date) {
    function formatDate(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    if (!date || date.length <= 0) {
      const dateLabels = [];
      const today = new Date();

      for (let i = 6; i >= 0; i--) {
        const date = new Date();
        date.setDate(today.getDate() - i);
        const formattedDate = formatDate(date);
        dateLabels.push(formattedDate);
      }

      return dateLabels;
    } else {
      return date.map((d) => {
        const parsedDate = new Date(d);
        return formatDate(parsedDate);
      });
    }
  }

  function getHighlightedPoints(data) {
    return data.map((value) => {
      if (value > higherLimitData[0] || value < lowerLimitData[0]) {
        return {
          backgroundColor: highlightColor,
          borderColor: highlightColor,
          radius: 2,
        };
      } else {
        return {
          backgroundColor: "rgb(0, 208, 255)",
          borderColor: "rgb(0, 208, 255)",
          radius: 2,
        };
      }
    });
  }

  const data = {
    labels: getDateLabels(labelData),
    datasets: [
      // Higher limit data
      {
        label: dataSetName[2] || "Higher Limit",
        fill: false,
        // borderColor: 'rgba(60, 61, 153, 1)',
        borderColor: "red",
        data: higherLimitData || [],
        pointRadius: higherLimitData.length > 1 ? 0 : 3,
        pointHoverRadius: higherLimitData.length > 1 ? 0 : 3,
        borderWidth: 1.5,
        // pointBackgroundColor: getHighlightedPoints(higherLimitData).map(point => point.backgroundColor),
        // pointBorderColor: getHighlightedPoints(higherLimitData).map(point => point.borderColor),
        // pointRadius: getHighlightedPoints(higherLimitData).map(point => point.radius)
      },
      // Lower limit data
      {
        label: dataSetName[1] || "Lower Limit",
        fill: false,
        // borderColor: 'rgba(0, 96, 96, 1)',
        borderColor: "red",
        data: lowerLimitData || [],
        pointRadius: lowerLimitData.length > 1 ? 0 : 3,
        pointHoverRadius: lowerLimitData.length > 1 ? 0 : 3,
        borderWidth: 1.5,
        // pointBackgroundColor: getHighlightedPoints(lowerLimitData).map(point => point.backgroundColor),
        // pointBorderColor: getHighlightedPoints(lowerLimitData).map(point => point.borderColor),
        // pointRadius: getHighlightedPoints(lowerLimitData).map(point => point.radius)
      },
      // Control line data
      {
        label: dataSetName[3] || "Control Line",
        fill: false,
        borderColor: "blue",
        borderWidth: 1.5,
        data: controlLineData || [],
        pointBackgroundColor: getHighlightedPoints(controlLineData).map(
          (point) => point.backgroundColor
        ),
        pointBorderColor: getHighlightedPoints(controlLineData).map(
          (point) => point.borderColor
        ),
        pointRadius: getHighlightedPoints(controlLineData).map(
          (point) => point.radius
        ),
      },
    ],
  };

  const options = {
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false, // Optionally hide tick marks on the axis
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: true,
          },
          ticks: {
            beginAtZero: true,
            // min: 1.5, // Start range at 1.5
            // max: 4, // End range at 4
            // stepSize: 0.5, // Increment ticks by 0.5
          },
        },
      ],
    },
    legend: {
      display: false,
      position: "bottom",
      labels: {
        usePointStyle: true,
        generateLabels: (chart) => {
          const datasets = chart.data.datasets;

          return datasets.map((dataset, i) => ({
            text: dataset.label,
            fillStyle: dataset.borderColor,
            hidden: !chart.isDatasetVisible(i),
            lineCap: dataset.borderCapStyle,
            lineDash: dataset.borderDash,
            lineDashOffset: dataset.borderDashOffset,
            lineJoin: dataset.borderJoinStyle,
            strokeStyle: dataset.borderColor,
            pointStyle: "circle",

            datasetIndex: i,
          }));
        },
      },
      onClick: null,
    },

    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };

  return (
    <div className="chart-wrapper custom-chart-wrapper">
      <Line data={data} plugins={[noDataPlugin]} options={options} />
    </div>
  );
};

export default SecondLineChart;
